import { Box, Button, Image, Link } from "@drone-js/core";
import { useUrlBuilder } from "apps/commons/hooks/useUrlBuilder";
import { LanguageSwitcher } from "libs/languageSwitcher";
import type { FunctionComponent } from "react";
import { useParams } from "router";
import { PartnerMarketingLayout } from "./PartnerMarketingLayout";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";
import { usePassedPropertyWizardSectionValue } from "./passedPropertyWizardSectionAtom";

const ListYourPlaceButton: FunctionComponent = () => {
    const {
        heroSectionViewModel: { listMyPropertyText },
    } = usePartnerMarketingModelValue();
    const isPassedHeroSection = usePassedPropertyWizardSectionValue();
    const urlBuilder = useUrlBuilder();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    if (!isPassedHeroSection) return null;

    return (
        <Box
            qM={{
                display: "flex",
            }}
            display="none"
        >
            <Button
                variant="label"
                hierarchy="primary"
                data-element-name="list-your-property"
                label={listMyPropertyText}
                onClick={scrollToTop}
                href={urlBuilder.onboardingUrl()}
            />
        </Box>
    );
};

const ULSigninButton: FunctionComponent = () => {
    const { isAuthenticated, signinText } = usePartnerMarketingModelValue();
    const urlBuilder = useUrlBuilder();

    if (isAuthenticated) return null;

    return (
        <Button
            hierarchy="secondary"
            variant="label"
            href={urlBuilder.signInUrl()}
            label={signinText}
            data-element-name="sign-in"
            size="l"
        />
    );
};

const AgodaLogo: FunctionComponent = () => {
    const { lang } = useParams("/:lang/list-my-property");

    return (
        <Box height="100%" py="4">
            <Link href={`https://agoda.com/${lang}`}>
                <Image
                    src="https://cdn6.agoda.net/images/kite-js/logo/agoda/color-default.svg"
                    alt="Agoda"
                    height="100%"
                    width="80px"
                    loading="immediate"
                />
            </Link>
        </Box>
    );
};

export const Navbar: FunctionComponent = () => {
    return (
        <Box
            as="nav"
            borderWidth={["0", "0", "1"]}
            borderColor="base.subtle"
            backgroundColor="base.surface"
            borderStyle="solid"
            position="fixed"
            width="100%"
            zIndex={99}
        >
            <PartnerMarketingLayout col={10}>
                <Box height="76px" display="flex" py="16" width="100%" justifyContent="space-between">
                    <AgodaLogo data-test-id="agoda-logo" />
                    <Box display="flex" gap="24">
                        <ULSigninButton />
                        <ListYourPlaceButton data-test-id="list-your-place-button" />
                        <LanguageSwitcher
                            languageFlagElementName="select-language"
                            languageFlagSelectorElementName="language-selector-link"
                        />
                    </Box>
                </Box>
            </PartnerMarketingLayout>
        </Box>
    );
};
